/* eslint-disable */
import React, { useEffect, useState } from "react";
import Select from "react-select";
// import DashboardSection from "../../DashboardContainer/DashboardSection";
import DashboardSection from "../../../DashboardContainer/DashboardSection";
// import DomainTile from "../../DomainTile/DomainTile";
import DomainTile from "../../../DomainTile/DomainTile";
import DsoBarChartComp from "./DsoBarChartComp";
import ContractBarLineChartComp from "./ContractBarLineChartComp";
import styles from "./ContractValueDsoDrilldown.module.css";
import "./ContractValueDsoDrilldown.css";
import axios from "axios";
import config from '../../../../config/config';
import { setQuarter } from "date-fns";
import { usePopupManager } from '../../../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../../../constants';
import { useLocation } from 'react-router-dom';

const ContractValueDsoDrilldown = () => {

  const location = useLocation();
  // const { entityData, geographyData, yearData, quarterData, monthData } = location.state || {};
  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    monthData: null,
    quarterData: null,
  };
  
    const RegionOptions = [
      // { value: "undefined", label: "Select" },
      // { value: "0", label: "-All-" },
      { value: "Domestic", label: "Domestic" },
      { value: "International", label: "International" },
    ];

    const quarterOptionss = [
      // { value: "undefined", label: "Select" },
      // { value: "0", label: "-All-" },
      { value: "2", label: "Q1" },
      { value: "3", label: "Q2" },
      { value: "4", label: "Q3" },
      { value: "1", label: "Q4" },
    ];
  
    const monthOptionss = [
      { value: "1", label: "Jan" },
      { value: "2", label: "Feb" },
      { value: "3", label: "Mar" },
      { value: "4", label: "Apr" },
      { value: "5", label: "May" },
      { value: "6", label: "Jun" },
      { value: "7", label: "Jul" },
      { value: "8", label: "Aug" },
      { value: "9", label: "Sep" },
      { value: "10", label: "Oct" },
      { value: "11", label: "Nov" },
      { value: "12", label: "Dec" },
    ];
   
    const quarterToMonths = {
      2: ["4", "5", "6"],  // Apr–Jun
      3: ["7", "8", "9"],  // Jul–Sep
      4: ["10", "11", "12"], // Oct–Dec
      1: ["1", "2", "3"]   // Jan–Mar
    };
  
  const [hasApplied, setHasApplied] = useState(false);
  
  const [filters, setFilters] = useState(initialFilters);

  const { API_BASE_URL } = config;

  const { showPopup } = usePopupManager();

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState(monthOptionss);
  const [quarterOptions, setQuarterOptions] = useState(quarterOptionss);

  const [entity, setEntity] = useState([]);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [quarter, setQuarter] = useState([]);
  const [Region, setRegion] = useState(RegionOptions[0]);
  const [TotalContractChartData, setTotalContractChartData] = useState([]);
  const [DSOChartData, setDSOChartData] = useState([]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const fetchEntityOptions = async () => {
    setEntityOptions(filters.entityList);
    // console.log("------------------")
    // try {
    //   const response = await axios
    //     .get(`${API_BASE_URL}/api/finance-entity`, {
    //       headers: {
    //         // Authorization: `Bearer ${token}`,
    //         Authorization: "Basic YWRtaW4xOjEyMw==",
    //       },
    //     })
    //     .then((response) => {
    //       // console.log("Response data------->",response.data)
    //       setEntityOptions(response.data);
    //     });
    // } catch (error) {
    //   console.error("Error fetching finance-entity options:", error);
    // }
  };

  const fetchYearOptions = async () => {
    setYearOptions(filters.yearList);
    // try {
    //   const response = await axios.get(`${API_BASE_URL}/api/finance-year`, {
    //     headers: {
    //       // Authorization: `Bearer ${token}`,
    //       Authorization: 'Basic YWRtaW4xOjEyMw==',
    //     },
    //   })
    //   .then((response) => {
    //     // console.log("Response data------->",response.data)
    //     setYearOptions(response.data);
    //   })
    // } catch (error) {
    //   console.error('Error fetching finance-year options:', error);
    // }
  };

  const fetchMonthOptions = async () => {
        setMonthOptions(filters.monthList);
    // try {
    //   const response = await axios.get(`${API_BASE_URL}/api/finance-month`, {
    //     headers: {
    //       // Authorization: `Bearer ${token}`,
    //       Authorization: 'Basic YWRtaW4xOjEyMw==',
    //     },
    //   })
    //   .then((response) => {
    //     setMonthOptions(response.data);
    //   })
    // } catch (error) {
    //   console.error('Error fetching finance-month options:', error);
    // }
  };

  // const fetchQuarterOptions = async () => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/api/finance-quarter`, {
  //       headers: {
  //         // Authorization: `Bearer ${token}`,
  //         Authorization: 'Basic YWRtaW4xOjEyMw==',
  //       },
  //     })
  //     .then((response) => {
  //       setQuarterOptions(response.data);
  //     })
  //   } catch (error) {
  //     console.error('Error fetching finance-tower options:', error);
  //   }
  // };

  const handleApply = () => {
    if (Array.isArray(entity) && entity.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    
    if (Array.isArray(year) && year.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select year.",
      });
      return;
    }

      fetchTotalContractChartData();
      fetchDSOChartData();
  };

  
  const handleEntityChange = (selected) => {
    if (selected) {
      setEntity(selected);
      setFilters(prev => ({ ...prev, entityData: selected }));
    } else {
      setEntity([]);
    }
  };

  const handleYearChange = (selected) => {
    if(selected){
      setYear(selected);
      setFilters(prev => ({ ...prev, yearData: selected }));
    } else{
      setYear([])
    }
    // setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleMonthChange = (selected) => {
    if (selected && selected.length > 0) {
      // store array of values like [1,2,3]
      setMonth(selected);
      setFilters(prev => ({ ...prev, monthData: selected }));
    } else {
      setMonth([]);
    }
  };

  // const handleQuarterChange = (selected) => {
  //   if(selected){
  //     setQuarter(selected);
  //     setFilters(prev => ({ ...prev, quarterData: selected }));
  //   } else {
  //     setQuarter([])
  //   }

  //   if (selected?.value) {
  //     setMonth(
  //       monthOptions.filter((m) =>
  //         quarterToMonths[selected.value].includes(m.value)
  //       )
  //     );
  //     setFilters(prev => ({
  //       ...prev,
  //       monthData: monthOptions.filter(m =>
  //         quarterToMonths[selected?.value]?.includes(m.value) // Safe access
  //       )
  //     }));
  //   } else {
  //     setMonth([]);
  //   }
  //   // setFilters(prev => ({ ...prev, entityData: selected }));
  // };

  const handleQuarterChange = (selected) => {
    if (selected && selected.length > 0) {
      setQuarter(selected);
      setFilters(prev => ({ ...prev, quarterData: selected }));
      const selectedMonths = selected.flatMap(q =>
        quarterToMonths[q.value] || []
      );
      const filteredMonths = monthOptionss.filter(m =>
        selectedMonths.includes(m.value)
      );
      setMonth(filteredMonths);
      setFilters(prev => ({ ...prev, monthData: filteredMonths }));
    } else {
      setQuarter([]);
      setMonth([]);
      setFilters(prev => ({
        ...prev,
        quarterData: [],
        monthData: []
      }));
    }
  };
  
  const fetchTotalContractChartData = async () =>{
    const entityval = entity?.map((item)=> item?.value);
    const yearval = year?.map((item)=> item?.value);
    // const monthval = month?.map((item)=> item?.value);
    const monthval = Array.isArray(month)? month.map((item) => item?.value): [];
    const quarterval = quarter?.map((item)=> item?.value);
    setIsLoading(true);
    const axios = require('axios');
    let data = JSON.stringify({
      selectedEntity: entityval,
      selectedYear: yearval,
      selectedQuarter: quarterval,
      selectedMonth: monthval.join(","),
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_BASE_URL}/api/finance-contractvalue-drilldown`,
      headers: { 
        'Content-Type': 'application/json', 
        'Authorization': 'Basic YWRtaW4xOjEyMw=='
      },
      data : data
    };

    await axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      setTotalContractChartData(response.data);
      setIsLoading(false);
      setShowDashboard(true);
    })
    .catch((error) => {
      console.log(error);
    });

  }

  const fetchDSOChartData = async (regionValue) =>{
    const entityval = entity?.map((item)=> item?.value);
    const yearval = year?.map((item)=> item?.value);
    // const monthval = month?.map((item)=> item?.value);
    const monthval = Array.isArray(month)? month.map((item) => item?.value): [];
    const quarterval = quarter?.map((item)=> item?.value);
    // const regionval = Region?.value;
    const regionval = regionValue ? regionValue.value : Region?.value;
    setIsLoading(true);
      const axios = require('axios');
      let data = JSON.stringify({
        selectedEntity: entityval,
        selectedYear: yearval,
        selectedQuarter: quarterval,
        selectedMonth: monthval.join(","),
        selectedRegion: regionval,
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${API_BASE_URL}/api/finance-dos-drilldown`,
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': 'Basic YWRtaW4xOjEyMw=='
        },
        data : data
      };

      await axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setDSOChartData(response.data);
        setIsLoading(false);
        setShowDashboard(true);
      })
      .catch((error) => {
        console.log(error);
      });

  }

  const stackedTotalContractDatasets = [
    {
      type: "line",
      label: "Variance (%)",
      data: TotalContractChartData.map((d) => d.variance),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.0,
      fill: false,
      pointRadius: 4,
    },
    {
      type: "bar",
      label: "Annual Target",
      data: TotalContractChartData.map((d) => d.annual_target),
      // backgroundColor: "#2196F3",
      backgroundColor: (ctx) => {
        const value = ctx.raw;
        return value < 0 ? "red" : "#2196F3";
      },
      stack: "combined",
      order: 1,
      barThickness: 30,
    },
    {
      type: "bar",
      label: "YTD Target",
      data: TotalContractChartData.map((d) => d.ytd_target),
      // backgroundColor: "#FFC107",
      backgroundColor: (ctx) => {
        const value = ctx.raw;
        return value < 0 ? "red" : "#FFC107";
      },
      stack: "combined",
      order: 1,
      barThickness: 30,
    },
    {
      type: "bar",
      label: "Actual",
      data: TotalContractChartData.map((d) => d.actual_target),
      // backgroundColor: "#00BCD4",
      backgroundColor: (ctx) => {
        const value = ctx.raw;
        return value < 0 ? "red" : "#00BCD4";
      },
      stack: "combined",
      order: 1,
      barThickness: 30,
    },
  ];

  const stackedbusinessDatasets = [
    {
      type: "bar",
      label: "Annual Target",
      data: DSOChartData.map((d) => d.annual_target),
      backgroundColor: "#2196F3",
      stack: "combined",
      order: 1,
    },
    {
      type: "bar",
      label: "YTD Target",
      data: DSOChartData.map((d) => d.ytd_target),
      backgroundColor: "#FFC107",
      stack: "combined",
      order: 1,
    },
    {
      type: "bar",
      label: "Actual",
      data: DSOChartData.map((d) => d.actual_target),
      backgroundColor: "#00BCD4",
      stack: "combined",
      order: 1,
    },
    {
      type: "line",
      label: "Variance (%)",
      data: DSOChartData.map((d) => d.variance),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.0,
      fill: false,
      pointRadius: 9,
    },
  ];


  const handleStatus = (val) => {
    setRegion(val);
    fetchDSOChartData(val);
  }
  
  const handleReset = () => {
    setShowDashboard(false);
    setEntity([]);
    setYear([]);
    setMonth([]);
    setQuarter([]);
  };

  
  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    fetchMonthOptions();
    // fetchQuarterOptions();
  }, []);

  useEffect(() => {
    if (
      entityOptions.length &&
      yearOptions.length &&
      monthOptions.length &&
      quarterOptions.length
    ) {
      if (filters.entityData?.length > 0) {
        const entities = entityOptions.filter(opt =>
          filters.entityData.some(m => m.value === opt.value)
        );
        if (entities.length > 0) setEntity(entities);
      }
  
      if (filters.yearData?.length > 0) {
        const years = yearOptions.filter(opt =>
          filters.yearData.some(m => m.value === opt.value)
        );
        if (years.length > 0) setYear(years);
      }
  
      if (filters.monthData?.length > 0) {
        const months = monthOptionss.filter(opt =>
          filters.monthData.some(m => m.value === opt.value)
        );
        if (months.length > 0) setMonth(months);
      }
  
      if (filters.quarterData?.length > 0) {
        const quarters = quarterOptionss.filter(opt =>
          filters.quarterData.some(m => m.value === opt.value)
        );
        if (quarters.length > 0) setQuarter(quarters);
      }
      setHasApplied(true);
    }
  }, [entityOptions, yearOptions, monthOptions, quarterOptions]);
  
  useEffect(() => {
    if (hasApplied === true ) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
        <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity <span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                  value={entity}
                // onChange={setEntity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={false}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year <span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                // onChange={setYear}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={false}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                // onChange={setQuarter}
                onChange={handleQuarterChange}
                options={quarterOptionss}
                isSearchable={false}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                // onChange={setMonth}
                onChange={handleMonthChange}
                options={monthOptionss}
                isSearchable={false}
                isMulti={true}
                styles={customStyles}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
            
          </div>
        </div>
      )}

{showDashboard && (

      <div>
        <div className="row">
          <div className="col-md-12">
            <DomainTile
              title="Drill Through View - Revenue"
              showBackButton={true} mainPagePath="/Finance-Page" detailState = {filters}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DashboardSection title="Total Contract Value" disableDetailView={true}>
                <ContractBarLineChartComp chartData={TotalContractChartData} datasets={stackedTotalContractDatasets}/>
            </DashboardSection>
          </div>
          <div className="col-md-12 mt-2">
            <DashboardSection title="DSO" disableDetailView={true}>
            <div className="row d-flex justify-content-end mb-5">
                <div className='col-lg-3'>
                  <Select
                    value={Region}
                    onChange={handleStatus}
                    options={RegionOptions}
                    isSearchable={false}
                  />
                </div>
              </div>
              <DsoBarChartComp data={DSOChartData}/>
            </DashboardSection>
          </div>
        </div>
        <div className="mt-2">
          <span style={{ color: 'red', fontSize:'12px' }}>NOTE : Red Color Indicates Negative Values in Charts *</span>
        </div>
      </div>
      )}
    </>
  );
};

export default ContractValueDsoDrilldown;